<template>
    <div>
      <div class="console-wrap">
        <div :class="{ 'console-header': true, nbd: isConsoleHome }">
          <div class="con-box">
            <div class="account" style="display:flex">
              <div class="flex-b nw">
                <!-- <p style="margin-right: 20px; font-weight: bold; font-size: 16px">控制台</p> -->
                <img
                  class="photo"
                  :src="
                currentAuthUser.imgPath
                  ? fileOperShow(currentAuthUser.imgPath)
                  : ''
              "
                  onerror="this.src='/images/web/login_user_icon.png'"
                />
                <div class="moreInfo">
                  <img
                    style="width: 20px; height: 20px; margin-right: 0"
                    v-if="currentAuthUser.userStemFrom === -16 && !isInDingTalk"
                    src="/images/icon/dingIcon.png"
                    alt=""
                  />
                  <img style="max-height: 28px" src="../static/images/ywt_logo.png" alt="">
                  <span class="name">（{{corpName.substring(0, 5)}}）</span>
                </div>
                <i class="el-icon-caret-bottom" style="font-size: 24px;"></i>
              </div>
              <div class="comp-expand">
                <change-account
                  @showExpandIcon="showExpandIcon"
                  :users="consoleUsers"
                  :ywtAccountChoose="true"
                  :lineHeight="59"
                />
              </div>
            </div>
            <div style="display: flex; justify-content: flex-end">
              <ul>
                <li
                  v-for="(item, index) in endConsoleMenus"
                  :key="index"
                  :id="'menu' + index"
                  :class="{active: menuActive === item.value}"
                  @click="toYwtMenusFn(item)"
                >
                  <span>{{ item.name }}</span>
                </li>
              </ul>
              <div class="ls-sh">
                <el-button class="backBZ" @click="turnBack">返回首页</el-button>
              </div>
            </div>
          </div>
        </div>
        <nuxt ref="nuxtPageRef" />
      </div>
    </div>
</template>

<script>
  import { fileOperShow } from "../assets/js/http-serve/http-methods";
  import {setCurrentUser} from "../assets/js/http-serve/corp/common";
  import ChangeAccount from "@/components/change-account";
  import { isInDingTalk } from "../assets/js/utils/ding-env";
    export default {
        name: "ywtLayout",
      components: {
        ChangeAccount,
      },
      data() {
          return {
            isInDingTalk,
            fileOperShow: fileOperShow,
            menuActive: 102,
            endConsoleMenus: [
              {name: '模板管理', type: 'ywt', value: 102},
              {name: '审批设置', type: 'ywt',value: 15002},
              {name: '子账户管理',type: 'ywt', value: 15001},
              {name: '用户首页', type: 'ywt',value: 100},
              {name: '归档设置', type: 'ywt',value: 15003},
              // {name: '企业账户中心', type: 'jzq', value: 5},
            ],
          }
      },
      computed: {
        // 获取拥有控制台权限的用户
        consoleUsers () {
          try {
            let users = this.$store.getters.allAuthUser.bindCorpUsers;
            let consoleUsers = [];
            // console.log(this.$store.getters.allAuthUser);
            if (this.$store.getters.allAuthUser.corpCreateFlag === 1) {
              // 超级管理员
              consoleUsers.push(this.$store.getters.allAuthUser.manCorpUser);
            }
            users.forEach(user => {
              if (user.perms && user.perms.length > 0) {
                consoleUsers.push(user);
              }
            });
            return consoleUsers;
          } catch (e) {
            return [];
          }
        },
        corpName () {
          if (
            this.currentAuthUser.userType == 1 ||
            this.currentAuthUser.userType == 0
          ) {
            //外部用户，一般情况下应该是超级管理员
            if (
              this.$store.getters.allAuthUser &&
              this.$store.getters.allAuthUser.corpCreateFlag == 1 &&
              this.$store.getters.allAuthUser.manCorpUser
            ) {
              return this.$store.getters.allAuthUser.manCorpUser.corpName || "";
            }
          }
          return this.currentAuthUser.corpName || "";
        },
        // 是否控制台首页
        isConsoleHome () {
          return this.$route.path.indexOf("/console/consoleIndex") > -1;
        },
        currentAuthUser () {
          return this.$store.getters.currentAuthUser || {};
        },
        authUser () {
          return this.$store.getters.authUser || {};
        },
      },
      mounted() {
        this.$nuxt.$on('menuActiveFn', this.menuActiveFn);
      },
      beforeDestroy() {
        this.$nuxt.$off('menuActiveFn', this.menuActiveFn);
      },
      methods: {
        menuActiveFn(val) {
          this.menuActive = val;
        },
        showExpandIcon() {

        },
      //  业务通菜单
        toYwtMenusFn(item) {
          if (item.type === 'jzq') {
            this.$router.push({
              path: "/console/member",
              query: { signStatus: 2 }
            })
          } else if (item.value !== this.menuActive) {
            this.$refs.nuxtPageRef.$children[0].ywtChangeMenuFn({value: item.value, oldVal: this.menuActive})
            this.menuActive = item.value;
          }
        },
      //  out
        turnBack () {
          this.$router.push({ path: "/viewIndex" })
          setTimeout(() => {
            setCurrentUser(this.$store.getters.allAuthUser.accountInfoVO);
          }, 500);

        },
      },
    }
</script>

<style scoped lang="less">
  @import url('../assets/style/cssVariable.less');
  @media (max-width: 1366px) {
    .console-header {
      .moreInfo{
        // display: none !important;
        .name{
          white-space: nowrap; /* 禁止文本换行，强制单行显示 */
          overflow: hidden; /* 隐藏超出容器的内容 */
          text-overflow: ellipsis; /* 超出部分使用省略号表示 */
          cursor: pointer; /* 鼠标悬停时显示指针，表示可点击 */
        }
      }
    }
    .con-box{
      width: 100% !important;
    }
  }
  .backBZ {
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: @ebq-red;
    padding: 7px 10px;
    border-radius: 4px;

    &:hover {
      background: @ebq-bg-turn;
    }
  }

  .console-header {
    height: 60px;
    line-height: 60px;
    /*background: rgba(41, 2, 2, 1);*/
    background: #ec1c1c;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    position: relative;
    z-index: 10;

    &.nbd {
      background: rgba(255, 255, 255, 0.1);
    }
    .moreInfo{
      display: flex;
      align-items: center;
    }

    ul {
      list-style: none;
      margin-right: 20px;
      width: 47vw;
      display: flex;
      justify-content: flex-end;
      flex-wrap: nowrap;
    }

    li {
      cursor: pointer;
      float: left;
      list-style: none;
      text-align: center;
      width: 9vw;
      height: 60px;

      a {
        display: block;
        color: rgba(255, 255, 255, 1);
        text-decoration: none;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.31);
      }

      &.active {
        background: rgba(255, 255, 255, 0.31);
      }
    }

    .account {
      z-index: 1;
      position: relative;

      .nw {
        position: relative;
        z-index: 6;
      }

      .photo {
        width: 25px;
        height: 25px;
        margin-right: 5px;
        border-radius: 50%;
      }

      .name {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 12vw;
        // max-width: 220px;
        // min-width: 160px;
        margin-right: 3px;
        cursor: pointer;
      }

      .comp-expand {
        width: 0;
        height: 0;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
        position: absolute;
        z-index: -1;
        top: 56px;
        left: 2px;
        background-color: #ffffff;
        transform: translateY(-100%);
        /*transition: all .3s;*/
        opacity: 0;
        color: #000000;
        border-radius: 5px;
        overflow: hidden;
        /*width: 130%;*/
        transition-property: opacity, top, transform;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease;

        /deep/ .change-account {
          li {
            border-bottom: solid 1px #ddd;
            .current-user {
              right: 15px;
            }
          }

          .search-profile {
            position: absolute;
            background-color: #ffffff;
            padding: 0 20px;
            border-bottom: solid 1px #ddd;
          }

          .wrap {
            overflow-y: auto;
            max-height: 420px;
          }
        }
      }

      &:hover {
        .el-icon-arrow-right {
          transform: rotate(90deg);
        }

        .comp-expand {
          height: auto;
          min-width: 300px;
          /*z-index: 2;*/
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .flex-b {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover{
      .el-icon-caret-bottom{
        transform: rotate(180deg);
      }
    }
  }

  .con-box {
    width: 1366px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
  }

  .ls-sh {
    height: 100%;
    display: inline-block;
    position: relative;

    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-right: 5px;
      border-radius: 50%;
    }

    .icon {
      cursor: pointer;
      margin-left: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// layouts/ywtLayout.vue